var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGasStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 36,
    height: 36,
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 30,
    height: 42,
    rx: 3,
    fill: "#ef6c00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 11,
    width: 20,
    height: 10,
    rx: 1,
    fill: "#fff3e0",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 28,
    width: 6,
    height: 8,
    fill: "#ffffff",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 18 H50 V34",
    fill: "none",
    stroke: "#ef6c00",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 34 H44 V46",
    fill: "none",
    stroke: "#ef6c00",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 48,
    width: 14,
    height: 8,
    rx: 1,
    fill: "#ef6c00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasStation);
export default __webpack_public_path__ + "static/media/gas-station.ff71e9744ee0a912f68893ff26b66b38.svg";
export { ForwardRef as ReactComponent };